'use client';
import { useEffect, useState } from 'react';
import { BASE_SITE_KEY } from './constants';

export function useRecaptcha() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Kiểm tra nếu grecaptcha đã được tải
    if (window.grecaptcha) {
      setIsLoaded(true);
      return;
    }

    // Nếu đang tải, không tải lại
    if (isLoading) return;

    setIsLoading(true);

    // Tải script động
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${BASE_SITE_KEY}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      setIsLoaded(true);
      setIsLoading(false);
    };

    script.onerror = () => {
      setIsLoading(false);
      //   console.error('Failed to load reCAPTCHA script');
    };

    document.head.appendChild(script);

    return () => {
      // Cleanup nếu cần, nhưng thường không cần vì script cần tồn tại
    };
  }, [isLoading]);

  const execute = async (action = 'submit') => {
    // Chờ cho đến khi grecaptcha có sẵn
    if (!window.grecaptcha) {
      await new Promise((resolve) => {
        const checkLoaded = () => {
          if (window.grecaptcha) {
            resolve();
          } else {
            setTimeout(checkLoaded, 100);
          }
        };
        checkLoaded();
      });
    }

    return await window.grecaptcha.execute(BASE_SITE_KEY, { action });
  };

  return { execute, isLoaded };
}
